import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/general/geOperLog/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/general/geOperLog',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/general/geOperLog',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/general/geOperLog/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/general/geOperLog',
    method: 'get',
    params: {
      id
    }
  })
}
